import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20and%20artistic%20manga%20reading%20atmosphere%2C%20Japanese%20style%20illustration%20with%20soft%20gradient%20background%20in%20warm%20amber%20and%20cream%20tones%2C%20abstract%20decorative%20elements%20like%20floating%20pages%20and%20brush%20strokes%2C%20cozy%20reading%20vibe%2C%20no%20text%2C%20clean%20minimal%20composition%2C%20high%20quality%20wallpaper%20style&width=1920&height=800&seq=hero-banner-manga&orientation=landscape"
        alt="香蕉漫画网 - 免费漫画阅读平台"
        className="absolute inset-0 w-full h-full object-cover object-center"
        fetchPriority="high"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4">
        <div className="text-center max-w-3xl">
          <h1 className="text-3xl md:text-5xl font-bold font-heading text-background-50 mb-4 leading-tight">
            漫画免费阅读 · 免费漫画大全
          </h1>
          <p className="text-base md:text-lg text-background-50/80 mb-8 leading-relaxed max-w-2xl mx-auto">
            香蕉漫画网汇聚海量漫画免费阅读资源，免费看漫画免费更新全集免费享，零成本畅享全本漫画。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/rexue"
              className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/30"
            >
              <span className="w-5 h-5 inline-flex items-center justify-center mr-1.5">
                <i className="ri-book-open-line"></i>
              </span>
              开始免费阅读
            </Link>
            <Link
              to="/category/riman"
              className="px-8 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-sm hover:bg-background-50/30 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <span className="w-5 h-5 inline-flex items-center justify-center mr-1.5">
                <i className="ri-fire-line"></i>
              </span>
              热门排行
            </Link>
          </div>
        </div>

        <div className="absolute bottom-8 flex items-center gap-2 text-background-50/60 text-xs">
          <span className="flex items-center gap-1">
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-check-line"></i>
            </span>
            全本免费
          </span>
          <span className="text-background-50/30">|</span>
          <span className="flex items-center gap-1">
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-check-line"></i>
            </span>
            每日更新
          </span>
          <span className="text-background-50/30">|</span>
          <span className="flex items-center gap-1">
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-check-line"></i>
            </span>
            海量资源
          </span>
        </div>

        <a
          href="#hot-recommend"
          className="absolute bottom-[-1px] left-1/2 -translate-x-1/2 w-10 h-10 flex items-center justify-center text-background-50/70 hover:text-background-50 animate-bounce cursor-pointer"
          aria-label="向下滚动"
        >
          <i className="ri-arrow-down-s-line text-xl"></i>
        </a>
      </div>
    </section>
  );
}